import React from "react";
import { Form, Input, Button, message } from "antd";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

interface LoginFormType {
  email: string;
  password: string;
}

const LoginForm = () => {
  const onFinish = async (values: LoginFormType) => {
    const { email, password } = values;
    try {
      await signInWithEmailAndPassword(auth, email, password);
      message.success("Connection réussie!");
    } catch (error) {
      message.error("Email ou mot de passe invalide(s)!");
    }
  };

  return (
    <div className="text-black bg-white h-screen">
      <div className="max-w-[300px] m-auto">
        <h1 className="w-fit m-auto p-4">Login</h1>
        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Email requis!" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Enter your password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;
